import React, { useContext, useEffect } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { EstateStatusItem } from "./EstateStatusItem";
import { AuthContext } from "../../AuthContextWrapper";
import { estateApi } from "../../apis";
import { Estate } from "../../models/Estate";

export const EstateSummaryCard = (): JSX.Element => {
  const { activeEstate, setActiveEstate } = useContext(AuthContext);

  const getStatus = async () => {
    if (activeEstate && !activeEstate.estateSummary) {
      // NOTE: clone so AuthContext scope will recognize new object and cause re-render
      const estate = Estate.from(activeEstate);
      estate.estateSummary = await estateApi.getSummary("first");
      setActiveEstate && setActiveEstate(estate);
    }
  };

  useEffect(() => {
    (async () => {
      if (activeEstate) {
        await getStatus();
        // console.log("activeEstate?.estateSummary", activeEstate?.estateSummary);
      }
    })();
  }, [activeEstate]);

  return (
    <Card
      sx={{
        mb: 5,
      }}
    >
      <CardContent
        sx={{
          mb: -2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            background:
              "linear-gradient(120.89deg, #734ED2 0%, #5E78E7 83.84%)",
            m: -2,
            color: "#fff",
          }}
        >
          <EstateStatusItem
            value={`$${activeEstate?.estateSummary?.totalAssetValue || "0"}`}
            description="Current estate value"
          />
          <EstateStatusItem
            value={`${activeEstate?.estateSummary?.percentageComplete || "0"}%`}
            description="Guide progress"
          />
          <EstateStatusItem value="0/5" description="Forms completed" />
        </Box>
      </CardContent>
    </Card>
  );
};
